<select class="form-control" [(ngModel)]="viewByModel" (ngModelChange)="onModelChanged()" *ngIf="!config.isCxOne">
    <option *ngFor="let item of options" [ngValue]="item">{{ item.display }}</option>
</select>
<div style="position: relative;">
    <sol-dropdown *ngIf="config.isCxOne"
        [(ngModel)]="viewByModel"
        [options]="options"
        (ngModelChange)="onModelChanged()"
        label="display"
        primaryKey="id"
        sortKey="index"
        sortOrder="asc"
        [required]="false"
        [showFooter]="false"
        [searchEnabled]="false"
        ></sol-dropdown>
    <!-- Overlay to prevent viewby from opening for prebuilt report -->
    <div
        *ngIf="dashboardManager?.isPrebuiltReport && config.isCxOne"
        style="position: absolute; top: -1px; left: -1px; right: -1px; bottom: -1px; z-index: 10; background: transparent; cursor: pointer;"
        (click)="handleInteraction($event)"
        (keydown)="handleInteraction($event)"
    ></div>
</div>